module.exports = __webpack_public_path__ + "img/15.a7e4e4cf.jpg";